export default "<div class=\"progress-spinner\">\n    <p-progressSpinner  strokeWidth=\"10\"></p-progressSpinner>            \n</div>";